/**
 * What a person has to do on a computer before it can print to the DYMO
 * labeler, as data: the note on the Labeling page and the settings page is
 * built from this, and docs/labels.md says the same in more words.
 */

/**
 * Where DYMO Connect for Desktop is downloaded. This is DYMO's support page —
 * the address the LabelWriter 550 user guide sends you to ("support.dymo.com")
 * redirects here — rather than a link to one installer file, because DYMO puts
 * the version number in the installer's file name and such a link goes stale
 * with the next release.
 */
export const DYMO_CONNECT_DOWNLOAD_URL = 'https://www.dymo.com/support';

/** The name DYMO gives the program, as it appears on that page and in the Start menu. */
export const DYMO_CONNECT_NAME = 'DYMO Connect for Desktop';

/** The setup steps, in order. Short on purpose; docs/labels.md has the detail. */
export const DYMO_SETUP_STEPS: readonly string[] = [
  `Install ${DYMO_CONNECT_NAME} on this computer.`,
  'USB: plug the printer in only after installing.',
  'Network (LAN): in DYMO Connect choose File > Add Network Printer — on every computer that will print.',
  'Load a 30336 roll (1 x 2-1/8 in), then reload this page.',
];
